import { render, staticRenderFns } from "./WalletFloatBtns.vue?vue&type=template&id=797218b0&"
import script from "./WalletFloatBtns.vue?vue&type=script&lang=js&"
export * from "./WalletFloatBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports